import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Button, Card, CardContent, Container, Typography } from '@mui/material';
import { CheckCircle } from '@mui/icons-material';
import LandingLayout from './LandingLayout';

interface PaymentSuccessState {
  planName?: string;
  planPrice?: string;
}

const PaymentSuccess: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = (location.state || {}) as PaymentSuccessState;

  return (
    <LandingLayout>
      <Container maxWidth="sm" sx={{ py: 8 }}>
        <Card>
          <CardContent sx={{ p: 5, textAlign: 'center' }}>
            <CheckCircle sx={{ fontSize: 64, color: 'success.main', mb: 2 }} />
            <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>
              Payment Successful
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
              Your subscription is now active and your account is ready.
            </Typography>
            {(state.planName || state.planPrice) && (
              <Box sx={{ mb: 3 }}>
                <Typography variant="body2" color="text.secondary">
                  Plan: {state.planName || 'Selected plan'}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Amount: {state.planPrice || 'Processed'}
                </Typography>
              </Box>
            )}
            <Button variant="contained" onClick={() => navigate('/dashboard')}>
              Go to Dashboard
            </Button>
          </CardContent>
        </Card>
      </Container>
    </LandingLayout>
  );
};

export default PaymentSuccess;
